import styled from 'vue3-styled-components';

export const ModalHeader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const ModalTitle = styled.h2`
    font-size: 1.5rem;
    color: #333;
    text-align: center;
`

export const ModalSubtitle = styled.span`
    font-size: 15px;
    color: #ff0000;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`

export const ModalBody = styled.div`
    margin-bottom: 20px;
`

export const InfoSection = styled.div`
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;

    h3 {
        color: #2c3e50;
        margin-top: 0;
        margin-bottom: 16px;
    }

    p {
        color: #495057;
        margin: 8px 0;
        font-size: 0.95rem;
    }
`

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
`

export const CancelButton = styled.button`
    background: #e9ecef;
    color: #495057;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
        background: #dee2e6;
    }
`

export const RentalGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    margin-bottom: 24px;
`;

export const RentalCard = styled.div`
    background: #f8f9fa;
    border-radius: 12px;
    border: 1px solid #e0e0e0;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
`;

export const RentalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

export const CustomerName = styled.span`
    font-size: 18px;
    font-weight: 600;
    color: #333;
`;

export const ProductName = styled.span`
    font-size: 14px;
    color: #666;
    background: #e9ecef;
    padding: 4px 8px;
    border-radius: 6px;
`;

export const MonthContainer = styled.div`
    display: flex;
    gap: 5px;
`;

export const MonthRental = styled.div`
    padding: 4px;
    border-radius: 5px;
    cursor: pointer;
    background-color: ${props => props.isSelected ? '#4CAF50' : '#e0e0e0'};
    color: ${props => props.isSelected ? '#ffffff' : '#333333'};
    transition: all 0.3s ease;
    font-weight: 500;
    font-size: 14px;

    &:hover {
        background-color: ${props => props.isSelected ? '#45a049' : '#d0d0d0'};
        transform: translateY(-2px);
    }
`;

export const RentalDates = styled.div`
    display: grid;
    gap: 12px;
    margin-bottom: 10px;
`;

export const DateItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const DateLabel = styled.span`
    font-size: 14px;
    color: #666;
`;

export const DateValue = styled.span`
    font-size: 14px;
    color: #333;
    font-weight: 500;
`;

export const ExtendButton = styled.button`
    width: 100%;
    padding: 10px;
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
    margin-top: 10px;

    &:hover {
        background: #0d3a45;
    }
`;

export const ActionButton = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 24px;
`;

export const CloseButton = styled.button`
    padding: 10px 24px;
    background: #e9ecef;
    color: #495057;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background: #dee2e6;
    }
`;

export const AccountButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 4px 10px;
    font-size: 13px;
    font-weight: 500;
    color: #ffffff;
    background: #10b981;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.1);

    &:hover {
        background: #059669;
        transform: translateY(-1px);
        box-shadow: 0 4px 6px rgba(37, 99, 235, 0.2);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 1px 2px rgba(37, 99, 235, 0.2);
    }
`;

export const TabContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 20px 0;
    width: 100%;
`

export const TabButton = styled.button`
    padding: 8px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    background: white;
    font-size: 14px;
    min-width: 120px;

    &:hover {
        background: #f0f0f0;
    }

    &.active {
        background: #0f4c5c;
        color: white;
        border-color: #0f4c5c;

        &:hover {
            background: #0f5c6c;
        }
    }
`

export const NoDataSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 18px;
    font-weight: 600;
    color: #333;
`

// * ================================================
// * 재고 관리 팝업
// * ================================================

export const InventoryGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 24px;
`;

export const InventoryCard = styled.div`
    background: #f8f9fa;
    border-radius: 12px;
    border: 1px solid #e0e0e0;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
`;

export const InventoryHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
`;

export const InventoryDetails = styled.div`
    display: grid;
    gap: 10px;
    margin-bottom: 15px;
`;

export const DetailItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const DetailLabel = styled.span`
    color: #666;
    font-size: 14px;
`;

export const DetailValue = styled.span`
    color: #333;
    font-weight: 500;
`;

export const StockValue = styled.span`
    color: ${props => props.isLow ? '#dc3545' : '#333'};
    font-weight: 600;
`;

export const OrderButton = styled.button`
    width: 100%;
    padding: 10px;
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background: #0d3a45;
    }
`;

export const BulkOrderGrid = styled.div`
    display: grid;
    gap: 20px;
    margin-bottom: 20px;
`;

export const CompanySection = styled.div`
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);

    &:hover {
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    }
`;

export const CompanyHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
`;

export const CompanyTitle = styled.h3`
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #2c3e50;
    padding: 8px 12px;
    border-radius: 6px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    gap: 8px;
    
    &::before {
        content: '';
        width: 4px;
        height: 24px;
        background: #0f4c5c;
        border-radius: 2px;
        margin-right: 8px;
    }

    &:hover {
        background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
        transform: translateY(-1px);
        transition: all 0.2s ease;
    }
`;

export const BulkOrderButton = styled(OrderButton)`
    width: auto;
    padding: 6px 12px;
    margin: 0;
    background: #10b981;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
    
    &:hover {
        background: #059669;
        transform: translateY(-1px);
        box-shadow: 0 4px 6px rgba(16, 185, 129, 0.3);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 1px 2px rgba(16, 185, 129, 0.2);
    }

    &::before {
        content: '📦';
        font-size: 20px;
    }
`;

export const ProductGrid = styled(InventoryGrid)`
    padding: 20px;
    margin: 0;
`;

export const SearchWrapper = styled.div`
    margin-bottom: 20px;
    background: #fff;
`

export const SearchForm = styled.form`
    width: 100%;
    margin: 0 auto;
`

export const SearchInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    justify-content: center;
`

export const SearchInput = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    background-color: #f8f9fa;

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
    }

    &::placeholder {
        color: #adb5bd;
    }
`

export const SearchButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 7px 10px;
    background-color: #0f4c5c;
    border: none;
    border-radius: 8px;
    color: white;
    cursor: pointer;

    &:hover {
        background-color: #0f5c6c;
    }
`

export const DontShowTodayWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px;
    font-size: 14px;
    color: #666;
    
    input[type="checkbox"] {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }
    
    label {
        cursor: pointer;
    }
`;

export const ModalFooter = styled.div`
    width: 100%;
    background: #fff;
    border-top: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px 12px 16px;
    box-sizing: border-box;
    margin: 0;
    position: sticky;
    bottom: -1px;
    left: 0;
    z-index: 10;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.03);
`;

export const DontShowTodayCheckboxWrapper = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    color: #666;
    user-select: none;
    cursor: pointer;

    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        accent-color: #0f4c5c;
        cursor: pointer;
    }
`;

export const ModalFooterCloseButton = styled.button`
    background: #adb5bd;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 8px 24px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s;
    max-width: 100%;
    box-sizing: border-box;
    &:hover {
        background: #868e96;
        color: #fff;
    }
`;